import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesSalesCompetitorsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesSalesCompetitorsPages;
